import React from 'react'
import { useAuthTokenInit } from '@hooks/auth/useAuthTokenInit'
import { useInitialConfiguration } from '@hooks/useInitialConfiguration'
import { ModalRootContainer } from '@components/foundation/modal/Modal'
import { useAppEventListener } from '@app/events/hooks/useAppEventListener'

/**
 * Internal widget used for initialization
 */
export const InitializerWidget: React.FC = () => {
  useAppEventListener()

  useAuthTokenInit()
  useInitialConfiguration()

  return <ModalRootContainer />
}
